<template>
  <div class="regDialogViewConatiner">
    <el-dialog
      :visible.sync="forgetVisible"
      :close-on-click-modal="false"
      width="418px"
      class="regDialog"
      :before-close="close"
    >
      <div class="center">
        <div class="title">更改密码</div>
        <p>
          <el-input
            placeholder="请输入手机号码"
            class="phoneInput"
            clearable
            :maxlength="11"
            name="userPhone"
            v-model="phone"
            style="color: #000;"
          >
            <i slot="prefix" style="color:#000;" class="ml5">+86</i>
          </el-input>
        </p>
        <p class="dfc">
          <el-input
            placeholder="请输入验证码"
            :maxlength="4"
            name="code"
            v-model="code"
            clearable
            ref="autofocusCode"
            class="mr5"
          >
          </el-input>
          <el-button plain :class="show ? 'getCodeBtn' : 'setCodeBtn'" @click="getCode" :disabled="!show">{{
            show ? "获取验证码" : count + "s后可重发"
          }}</el-button>
        </p>
        <p>
          <el-input
            placeholder="请输入6-20位密码"
            type="password"
            name="password"
            clearable
            v-model="password"
            :maxlength="20"
            :show-password="true"
          ></el-input>
        </p>
        <div class="submitView mb20 mt30">
          <el-button type="primary" class="regBtn" @click="changePwdEvent">更改密码</el-button>
        </div>
        <div class="tips dfcjsb mt20">
          <p></p>
          <p>想起密码？<a href="javascript:;" class="blueFont" @click="toLogin">去登录</a></p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: [],
  components: {},
  data() {
    return {
      phone: "",
      code: "",
      timer: "",
      show: true,
      count: "",
      password: "",
      autofocusCode: false,
      clickMark: false, //连点拦截
    };
  },
  computed: {
    ...mapState(["forgetVisible"]),
  },
  mounted() {},
  created() {},
  methods: {
    toLogin() {
      this.close();
      setTimeout(() => {
        this.$store.commit("setLoginVisible", true);
      }, 300);
    },
    close() {
      this.$store.commit("setForgetVisible", false);
    },
    //获取验证码
    getCode() {
      if (!this.phone) return this.$message.error("请输入正确的手机号");
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) return this.$message.error("请输入正确的手机号码");
      this.phone = Number(this.phone);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        let ajaxData = {
          mobilePhone: this.phone,
          verificationCodeType: 1,
        };

        this.$ajax.post("/kuaio/api/Member/Member/SentVerificationCode", ajaxData).then((res) => {
          this.code = "";
          this.$nextTick(() => {
            this.$refs.autofocusCode.$el.querySelector("input").focus();
          });
          if (res.code == 200) this.$message.success(res.msg);
          if (res.code != 200) this.$message.error("获取失败,请稍后再试");
        });
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //修改密码
    changePwdEvent() {
      if (this.clickMark) return;
      this.clickMark = true;
      setTimeout(() => {
        this.clickMark = false;
      }, 3000);
      if (!this.phone) return this.$message.error("请输入正确的手机号");
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) return this.$message.error("请输入正确的手机号码");
      if (!this.password) return this.$message.error("请输入正确的密码");
      let length = this.password.length;
      if (length < 6 || length > 20) return this.$message.error("请输入6-20位密码");
      if (!this.code || this.code.length != 4) return this.$message.error("请输入正确的验证码");
      let ajaxData = {
        mobilePhone: Number(this.phone),
        newPassword: this.$md5(this.password),
        verificationCode: this.code,
      };
      this.$ajax
        .post("/kuaio/api/Member/Member/ModifyPassword", ajaxData)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success({
              message: res.msg,
              duration: 1000,
              onClose: (res) => {
                this.toLogin();
              },
            });
          }
          if (res.code != 200) this.$message.error(res.msg);
        })
        .catch(function(e) {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.regDialogViewConatiner {
  .regDialog {
    .el-dialog__header {
      padding: 0;
    }
    .center {
      padding: 0 60px;
      text-align: center;
      .title {
        font-size: 18px;
        color: #000;
        font-weight: 600;
        margin-top: 20px;
        margin-bottom: 40px;
      }
      p {
        margin-bottom: 15px;
      }
      .getCodeBtn {
        background: #ddd;
        border: 1px solid #ddd;
        color: #000;
      }
      .setCodeBtn {
        background: #eee;
        border: 1px solid #eee;
        color: #999;
      }
      .regBtn {
        width: 100%;
      }
      .tips {
        color: #aaa;
      }
    }
    .newReg {
      height: 100px;
      background: #fffae4;
      border-radius: 0 0 6px 6px;
      .item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-left: 25px;
        padding-top: 10px;
        p {
          width: 50%;
          margin-bottom: 10px;
        }
        .el-icon-check {
          color: #000;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.regDialogViewConatiner {
  .el-dialog__headerbtn {
    font-size: 20px;
  }
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog {
  }
  .phoneInput {
    .el-input__prefix {
      display: flex;
      align-items: center;
    }
    .el-input__inner {
      color: #000;
      padding-left: 48px;
    }
  }
}
</style>
